import {FunctionComponent, ReactNode} from 'react';

export const InfiniteHorizontalSlidingContainer: FunctionComponent<{animate?: boolean; children: ReactNode[]}> = ({
  animate = true,
  children,
}) => {
  return (
    <div
      className='w-fit flex -translate-x-1/4 animate-horizontal-slide group-hover/trending-market-data-section:animation-play-state-paused data-[animate=false]:animation-play-state-paused'
      data-animate={animate}
    >
      {children}
    </div>
  );
};
